import React, { useState } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { useData } from "../../../../components/firebase/DataProvider";
import Gap from "../../../../components/Gap";
import isURL from "validator/lib/isURL";
import Grid from "@material-ui/core/Grid";
import AtomGap from "../../../../components/atoms/Gap";
import { useCollectionData } from "react-firebase-hooks/firestore";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import { useHistory } from "react-router";
import { Skeleton } from "@material-ui/lab";
import { firestore } from "../../../../components/firebase/FirebaseProvider";

function ScrollableTabsButtonForce() {
  const [value, setValue] = useState(0);
  const { categories, jenisBrand } = useData();
  // console.log(jenisBrand?.categories);
  const brandCollection = firestore.collection("brand");

  const [brands, loadingBrand, err] = useCollectionData(brandCollection, {
    idField: "id",
  });

  brands?.map(function (e) {
    if (!e.category) {
      e.category = "normal";
    }
  });

  // console.log(brands, err);

  const [cate, setCate] = useState(false);
  const theme = useTheme();
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  // sceleton manual

  const handleChange = (event, newValue) => {
    // console.log("asasa");
    setValue(newValue);
  };

  setTimeout(() => {
    setCate(true);
  }, 1000);

  // console.log(data.data)
  return (
    <div>
      <div
        style={{
          flexGrow: 1,
        }}
      >
        <AppBar position="static" color="default">
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="on"
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
            style={{ backgroundColor: "transparant" }}
            wrapped="true"
          >
            {categories
              .sort((a, b) => {
                return b.created_at.toMillis() - a.created_at.toMillis();
              })
              .map((item) => {
                const iconn =
                  item?.icon && isURL(item?.icon) ? item?.icon : null;

                if (!cate || loadingBrand) {
                  return (
                    <Tab
                      key={item.id}
                      label={
                        <Skeleton variant="rect" width={100} height={10} />
                      }
                      icon={<Skeleton variant="rect" width={30} height={30} />}
                    />
                  );
                }

                return (
                  <Tab
                    key={item.id}
                    label={item.nama}
                    icon={
                      <img
                        style={{ height: 30, width: 30 }}
                        src={iconn}
                        alt="icon"
                      />
                    }
                    {...a11yProps(item.id)}
                  />
                );
              })}
          </Tabs>
        </AppBar>
      </div>

      <div style={{ height: "auto", paddingBottom: "20%" }}>
        <div style={{ marginLeft: 40, marginTop: 10, marginBottom: -20 }}>
          <h2>Kategori Pilihan</h2>
        </div>
        <Gap height={20} />
        <div style={{ display: "flex", marginLeft: 30 }}>
          <Grid container>
            {categories[value]?.sub.map((a, index) => {
              const iconn = a.icon && isURL(a.icon) ? a.icon : null;

              return (
                <KategoriPilihan
                  value={value}
                  index={value}
                  key={index}
                  children={a.nama}
                  icon={iconn}
                  nilai={a}
                  load={cate || loadingBrand}
                />
              );
            })}
          </Grid>
        </div>

        {/* <Gap height={!miniScreen ? 50 : 30} /> */}

        <div
          style={{
            height: 0.5,
            backgroundColor: "#c4c4c4ba",
            marginTop: !miniScreen ? 20 : 50,
            marginLeft: 40,
            marginRight: 40,
            marginBottom: -10,
          }}
        />
        {jenisBrand?.categories?.map((item) => {
          const brandFilter = brands?.filter(
            (brand) => brand?.category === item
          );
          return (
            <>
              {brandFilter?.length > 0 ? (
                <>
                  <div style={{ marginLeft: 40, marginBottom: -15 }}>
                    <h2 style={{ textTransform: "capitalize" }}>
                      Brand {item !== "normal" ? item : ""}
                    </h2>
                  </div>
                  <div
                    style={{ display: "flex", marginLeft: 30, height: "auto" }}
                  >
                    <Grid container>
                      {brandFilter?.map((a, index) => {
                        return (
                          <BrandPilihan
                            value={a}
                            index={a.id}
                            key={index}
                            load={cate || loadingBrand}
                          />
                        );
                      })}
                    </Grid>
                  </div>
                </>
              ) : null}
            </>
          );
        })}
      </div>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `scrollable-force-tab-${index}`,
    "aria-controls": `scrollable-force-tabpanel-${index}`,
  };
}

KategoriPilihan.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function KategoriPilihan({ children, icon, value, index, nilai, load }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("tablet"));
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  const miniminiScreen = useMediaQuery(theme.breakpoints.down("413"));
  const [open, setOpen] = useState(false);

  const history = useHistory();

  const handleClose = () => {
    setOpen(false);
  };

  const handleClick2 = (a) => {
    const hasChild = a.sub?.length > 0;

    hasChild
      ? setOpen(true)
      : history.push(`/kategori/kategori2/${a.nama}/${a.id}`, {
          data: a,
        });
  };

  const handleClick3 = (a) => {
    const hasChild = a.sub?.length > 0;

    hasChild
      ? setOpen(true)
      : history.push(`/kategori/kategori3/${a.nama}/${a.id}`, {
          data: a,
        });
  };

  if (!load) {
    return (
      <div style={{ marginLeft: miniScreen ? 10 : 15, marginTop: 30 }}>
        <div
          style={{
            width: miniScreen ? 50 : 100,
            height: 100,
            padding: !miniScreen ? 5 : 10,
            marginRight: 30,
            marginLeft: 30,
          }}
        >
          <Tab
            label={<Skeleton variant="rect" width={100} height={10} />}
            icon={<Skeleton variant="rect" width={30} height={30} />}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
    >
      {value === index && (
        <div
          style={{ marginLeft: miniScreen ? 10 : 15, marginTop: 30 }}
          onClick={() => handleClick2(nilai)}
        >
          <div
            style={{
              width: miniScreen ? 50 : 100,
              height: 100,
              padding: !miniScreen ? 5 : 10,
              marginRight: 30,
              marginLeft: 30,
            }}
          >
            <img
              src={icon}
              alt="icon"
              style={{
                display: "block",
                width: miniminiScreen ? 20 : miniScreen ? 25 : 35,
                height: 35,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            />
            <Typography style={{ marginTop: 20, textAlign: "center" }}>
              {children}
            </Typography>
          </div>
        </div>
      )}
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title" style={{ display: "flex" }}>
            {children}
          </DialogTitle>
          <DialogContent style={{ display: "flex" }}>
            {nilai
              ? nilai?.sub.map((data, index) => {
                  return (
                    <DialogContentText key={index}>
                      <div onClick={() => handleClick3(data)}>
                        <AtomGap width={10} />
                        <div
                          style={{
                            marginLeft: 0,
                            width: 150,
                            height: 100,
                            padding: 5,
                          }}
                        >
                          <img
                            src={data.icon}
                            alt={icon}
                            style={{
                              display: "block",
                              width: 35,
                              height: 35,
                              marginLeft: "auto",
                              marginRight: "auto",
                            }}
                          />
                          <Typography
                            style={{ marginTop: 20, textAlign: "center" }}
                          >
                            {data.nama}
                          </Typography>
                        </div>
                      </div>
                    </DialogContentText>
                  );
                })
              : null}
          </DialogContent>
        </Dialog>
      </div>
    </div>
  );
}

function BrandPilihan({ value, index, load }) {
  const theme = useTheme();
  const miniScreen = useMediaQuery(theme.breakpoints.down("600"));
  const miniminiScreen = useMediaQuery(theme.breakpoints.down("413"));
  // const [bp] = useDocumentDataOnce(brandCollection.doc(value), {
  //   idField: "id",
  // });
  const history = useHistory();
  // console.log('ini props', bp)

  const handleClick = (a) => {
    history.push(`/kategori/brand/${a.nama}/${a.id}`, {
      data: a,
    });
  };

  if (!load) {
    return (
      <div style={{ marginLeft: miniScreen ? 10 : 15, marginTop: 30 }}>
        <div
          style={{
            width: miniScreen ? 50 : 100,
            height: 100,
            padding: !miniScreen ? 5 : 10,
            marginRight: 30,
            marginLeft: 30,
          }}
        >
          <Tab
            label={<Skeleton variant="rect" width={100} height={10} />}
            icon={<Skeleton variant="rect" width={30} height={30} />}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      // hidden={value !== index}
      id={`scrollable-force-tabpanel-${index}`}
      aria-labelledby={`scrollable-force-tab-${index}`}
      // onClick={(a) => console.log(value)}
    >
      <div
        style={{ marginLeft: miniScreen ? 10 : 15, marginTop: 30 }}
        onClick={() => handleClick(value)}
      >
        <div
          style={{
            width: miniScreen ? 50 : 100,
            height: 100,
            padding: !miniScreen ? 5 : 10,
            marginRight: 30,
            marginLeft: 30,
          }}
        >
          <img
            src={value.icon}
            alt="icon"
            style={{
              display: "block",
              width: miniminiScreen ? 20 : miniScreen ? 25 : 35,
              height: 35,
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
          <Typography style={{ marginTop: 20, textAlign: "center" }}>
            {value.nama}
          </Typography>
        </div>
      </div>
    </div>
  );
}

export default React.memo(ScrollableTabsButtonForce);
